import 'bootstrap/js/src/popover';
import 'bootstrap/js/src/tooltip';
import 'bootstrap/js/src/collapse';
import Modernizr from 'modernizr';
import LazyLoad from "vanilla-lazyload";
import Masonry from 'masonry-layout/dist/masonry.pkgd.min';

export default class Utils {
    
    static lazyload;
    
    constructor()
    {
        Utils.sticky_topbar();
        Utils.click();
        Utils.bootstrap();
        Utils.searchbox();
        Utils.smooth_scroll();
        Utils.lazyload = Utils.lazy();
        Utils.block_cover();
        Utils.obfuscation();
        Utils.toogle_menu_button();
        Utils.sticky_logo();
        Utils.init_masonry();
        Utils.manage_lang();
    }
    
    static click()
    {
        
        const trigger = '[data-trigger="wpiris-click"]';
        
        if ( !Modernizr.touchevents ) {
            let ctrl = 0;
            $( window ).on( 'keydown', function ( e ) {
                if ( e.which == 17 || e.which == 91 ) {
                    ctrl = true;
                }
            } );
            $( window ).on( 'keyup', function () {
                ctrl = false;
            } );
            
            $( document ).on( 'mouseup', trigger, function ( e ) {
                
                if ( e.target.tagName.toLowerCase() !== 'a' ) {
                    if ( e.which == 1 || e.which == 2 ) {
                        let blank = false;
                        let url   = $( this ).find( "a" ).attr( "href" );
                        if ( e.which == 2 ) {
                            blank = true;
                        } // Clic molette
                        if ( $( this ).find( "a" ).attr( "target" ) == "_blank" ) {
                            blank = true;
                        }
                        if ( blank || ctrl ) {
                            window.open( url, '_blank' );
                        } else {
                            window.location = url;
                        }
                        return false;
                    }
                }
                return false;
                
            } );
        } else {
            $( document ).on( 'click', trigger, function ( e ) {
                
                let blank = false;
                let url   = $( this ).find( "a" ).attr( "href" );
                if ( $( this ).find( "a" ).attr( "target" ) == "_blank" ) {
                    blank = true;
                }
                if ( blank ) {
                    window.open( url, '_blank' );
                } else {
                    window.location = url;
                }
                return false;
                
            } );
        }
    }
    
    static bootstrap()
    {
        if ( !Modernizr.touchevents ) {
            $( '[data-toggle="tooltip"]' ).tooltip( {
                                                        trigger: "hover",
                                                    } );
        }
        
        $( '[data-toggle="popover"]' ).popover();
    }
    
    static searchbox()
    {
        const trigger  = '[data-trigger="wpiris-search-layout"]',
              close    = '[data-trigger="wpiris-search-layout-close"]',
              $element = $( '[data-id="wpiris-search-layout"]' );
        
        $( document ).on( 'click', trigger, function ( e ) {
            e.preventDefault();
            $element.fadeIn().find( 'input' ).focus();
        } );
        
        $( document ).on( 'click', close, function ( e ) {
            e.preventDefault();
            $element.fadeOut();
        } );
    }
    
    static smooth_scroll()
    {
        const trigger = '[data-trigger="wpiris-scroll"]';
        
        $( document ).on( 'click', trigger, function ( e ) {
            e.preventDefault();
            
            const target     = $( this ).attr( "href" ) != '' ? $( this ).attr( "href" ) : $( this ).attr( "data-href" ),
                  duration   = 1000,
                  scroll_top = $( target ).offset().top - (undefined !== e.currentTarget.dataset.shift ? e.currentTarget.dataset.shift : 0);
            
            $( 'html, body' ).animate( {
                                           scrollTop: scroll_top
                                       }, {
                                           duration: duration,
                                           step: ( now, fx ) => {
                                               let real_pos = scroll_top;
                                               if ( fx.end !== real_pos ) {
                                                   fx.end = real_pos;
                                               }
                                           }
                                       } );
        } );
    }
    
    static lazy()
    {
        const lazyLoadInstance = new LazyLoad( {
                                                   elements_selector: '[data-src], [data-bg], [data-bg-hidpi]'
                                               } );
        window.onbeforeprint   = function () {
            lazyLoadInstance.loadAll();
        };
        
        return lazyLoadInstance;
    }
    
    static block_cover()
    {
        $( '.wp-block-cover:has(.wp-block-cover__inner-container a)' ).attr( 'data-trigger', 'wpiris-click' );
    }
    
    static obfuscation()
    {
        let element = "[data-obf]";
        if ( $( element ).length > 0 ) {
            if ( !Modernizr.touchevents ) {
                let ctrl = 0;
                $( window ).on( 'keydown', function ( e ) {
                    if ( e.which == 17 || e.which == 91 ) {
                        ctrl = true;
                    }
                } );
                $( window ).on( 'keyup', function () {
                    ctrl = false;
                } );
                
                $( document ).on( 'mouseup', element, function ( e ) {
                    let url    = atob( $( this ).attr( 'data-obf' ) );
                    let target = $( this ).attr( 'data-obf-target' );
                    if ( e.which == 1 || e.which == 2 ) {
                        let blank = false;
                        if ( e.which == 2 ) {
                            blank = true;
                        } // Clic molette
                        if ( target == "_blank" ) {
                            blank = true;
                        }
                        if ( blank || ctrl ) {
                            window.open( url, '_blank' );
                        } else {
                            window.location = url;
                        }
                        return false;
                    }
                    
                    return false;
                    
                } );
            } else {
                $( document ).on( 'click', element, function ( e ) {
                    let blank  = false;
                    let url    = atob( $( this ).attr( 'data-obf' ) );
                    let target = $( this ).attr( 'data-obf-target' );
                    if ( target == "_blank" ) {
                        blank = true;
                    }
                    if ( blank ) {
                        window.open( url, '_blank' );
                    } else {
                        window.location = url;
                    }
                    return false;
                } );
            }
        }
    }
    
    static toogle_menu_button()
    {
        $( '.navbarMenu' ).on( 'click', ( e ) => {
            e.preventDefault();
            $( e.currentTarget ).toggleClass( 'open' );
        } );
    }
    
    static sticky_logo()
    {
        const logo_sticky = document.querySelectorAll( '.logo-sticky' );
        let height        = 120;
        
        if ( document.body.contains( document.querySelector( '.header--large' ) ) ) {
            height = document.querySelector( '.header--large' ).offsetHeight;
        }
        
        $( document ).on( 'scroll', function () {
            
            if ( window.scrollY < height ) {
                logo_sticky.forEach( ( item ) => {
                    item.style.display = 'none';
                } );
            } else {
                logo_sticky.forEach( ( item ) => {
                    item.style.display = 'block';
                } );
            }
        } );
    }
    
    static init_masonry()
    {
        const elements = document.querySelectorAll( '[data-trigger="wpiris-masonry"]' );
        
        elements.forEach( element => {
            const masonry = new Masonry( element, {
                columnWidth: '.grid-sizer',
                gutter: '.gutter-sizer',
                itemSelector: '.grid-item',
                stamp: '.stamp'
            } );
        } );
    }
    
    static sticky_topbar()
    {
        $( window ).resize( () => {
            $( window ).on( 'scroll', () => {
                if ( $( window ).scrollTop() > 40 ) {
                    if ( !$( '.topbar' ).hasClass( 'sticky' ) ) {
                        $( '.topbar' ).addClass( 'sticky' );
                    }
                } else {
                    $( '.topbar' ).removeClass( 'sticky' );
                }
            } );
        } );
        
        $( window ).trigger( 'resize' );
    }
    
    static manage_lang()
    {
        $( document ).on( 'click', '.topbarItemLangSelector a', function () {
            let lang = $( this ).html();
            $( '#currentLang' ).html( lang );
        } );
    }
}
